import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectRoadTypeState } from '../selectors';

export const getData = createSelector(selectRoadTypeState, (state: State) => state.data);

export const getError = createSelector(selectRoadTypeState, (state: State) => state.error);

export const getLoading = createSelector(selectRoadTypeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectRoadTypeState, (state: State) => fn(state.data));
